import APIService from 'services/APIService';
import CalendarAction, { CalendarActionDTO } from '../../models/calendar/CalendarAction';
import ApplicationService from '../application/ApplicationService';

export default class CalendarService {
	private readonly actionListOrder = {
		released: 'order=created_at&direction=DESC',
		closed: 'order=closed_at&direction=DESC',
	};
	constructor(private readonly ApiService: APIService, private readonly applicationService: ApplicationService) {}

	fetchActionList(status?: 'released' | 'closed') {
		if (!this.applicationService.config()?.workflowsEnabled()) {
			return { items: [] };
		}

		let url = '/calendar/action';

		if (status) {
			url += `?status=${status}&${this.actionListOrder[status]}`;
		}

		return this.ApiService.get<{ items: CalendarActionDTO[] }>(url, undefined, undefined, {
			version: 'v2',
			controller: 'workflows',
		}).then(response => ({
			items: response.items.map(process => this.toModel(process)),
		}));
	}

	toModel(calendarAction: CalendarActionDTO): CalendarAction {
		return new CalendarAction(calendarAction);
	}
}
